'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = fieldToQuestion;
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _recompose = require('recompose');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function getErrors(props) {
  if (props.meta.active || !(props.meta.visited || props.meta.submitFailed)) {
    return [];
  }
  return props.meta.error;
}
function fieldToQuestion(Component) {
  var EnhancedComponent = (0, _recompose.withProps)(function (props) {
    return {
      onValueChange: props.input.onChange,
      onFocus: props.input.onFocus,
      onBlur: props.input.onBlur,
      disabled: props.meta.submitting,
      errors: getErrors(props),
      value: props.input.value
    };
  })(Component);
  EnhancedComponent.propTypes = {
    input: _propTypes2.default.shape({
      onChange: _propTypes2.default.func.isRequired,
      value: _propTypes2.default.any.isRequired,
      onFocus: _propTypes2.default.func,
      onBlur: _propTypes2.default.func
    }),
    meta: _propTypes2.default.shape({
      active: _propTypes2.default.bool.isRequired,
      visited: _propTypes2.default.bool.isRequired,
      submitFailed: _propTypes2.default.bool.isRequired,
      submitting: _propTypes2.default.bool.isRequired,
      error: _propTypes2.default.arrayOf(_propTypes2.default.string)
    })
  };
  return EnhancedComponent;
}